import React from 'react';
import { Snackbar, Box, Typography, IconButton, Stack } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

const iconMap = {
    success: <CheckCircleIcon sx={{ color: 'white', height: '24px', width: '24px' }} />,
    error: <ErrorIcon sx={{ color: 'white', height: '24px', width: '24px' }} />,
    warning: <WarningIcon sx={{ color: 'white', height: '24px', width: '24px' }} />,
    info: <InfoIcon sx={{ color: 'white', height: '24px', width: '24px' }} />,
};

export default function CustomAlert ({ openAlert, setOpenAlert, alert, setAlert }) {
    const { t } = useTranslation();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
        setAlert({
            severity: '',
            title: '',
            description: '',
            className: ''
        });
    };

    return (
        <Snackbar
            open={openAlert || alert.isOpen}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            autoHideDuration={6000}
            onClose={handleClose}
        >
            <Box
                className={alert.className}
                sx={{
                    color: 'white',
                    px: '16px',
                    py: '6px',
                    borderRadius: '6px',
                    gap: '12px',
                    width: 'auto',
                    minWidth: '562px',
                    height: 'auto',
                    minHeight: '76px'
                }}
            >
                <Stack direction={'row'} gap={1}>
                    <Box paddingY={0.5}>{iconMap[alert.severity]}</Box>
                    <Stack sx={{ height: '100%', paddingY: '8px' }} gap={1}>
                        {alert.title &&
                        <Typography variant="h4" color={'white'} fontWeight={400} >
                            {t(alert.title)}
                        </Typography>
                        }
                        {alert.description &&
                        <Typography variant="h4" color={'white'} fontWeight={400} fontSize={'14px'}>
                            {t(alert.description)}
                            {alert.data ?? null}
                        </Typography>
                        }
                    </Stack>
                </Stack>

                <IconButton disableRipple onClick={handleClose} sx={{ color: 'white' }}>
                    <CloseIcon sx={{ height: '24px', width: '24px' }} />
                </IconButton>
            </Box>
        </Snackbar>
    );
}
